document.documentElement.classList.add('has-js');

const header = document.querySelector('#header');
const progress = document.querySelector('.scroll-progress span');
let scheduled = false;

function updateScroll() {
  header.classList.toggle('is-scrolled', window.scrollY > 28);
  const travel = document.documentElement.scrollHeight - window.innerHeight;
  progress.style.width = `${travel > 0 ? window.scrollY / travel * 100 : 0}%`;
  scheduled = false;
}

window.addEventListener('scroll', () => {
  if (!scheduled) {
    scheduled = true;
    requestAnimationFrame(updateScroll);
  }
}, { passive: true });
updateScroll();

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revealItems = document.querySelectorAll('[data-reveal]');
if ('IntersectionObserver' in window && !reducedMotion) {
  const revealObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    }
  }, { threshold: 0.08, rootMargin: '0px 0px 100px 0px' });
  revealItems.forEach(item => revealObserver.observe(item));
} else {
  revealItems.forEach(item => item.classList.add('is-visible'));
}

const navLinks = [...document.querySelectorAll('.desktop-nav a')];
if ('IntersectionObserver' in window) {
  const sectionObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        navLinks.forEach(link => link.setAttribute('aria-current', String(link.hash === `#${entry.target.id}`)));
      }
    }
  }, { rootMargin: '-20% 0px -65% 0px' });
  for (const id of ['story', 'craft', 'collection']) {
    const section = document.getElementById(id);
    if (section) sectionObserver.observe(section);
  }
}
